module.exports = "/images/tos_icon.svg?dcd1f2f1aeb50adb9ecb481c67a5e163";